class KlevuFacts extends HTMLElement {
  connectedCallback () {
    this.els = {
      accordion: this.querySelector('[data-klevu-facet-el="accordion"]'),
    }

    this.setupListeners()
  }

  setupListeners () {
    document.addEventListener('click', event => {
      const targetElement = event.target
      if (!this.els.accordion.contains(targetElement) && targetElement !== this.els.accordion) {
        this.els.accordion.removeAttribute('open') // Hide the element
      }
    })
  }
}

if (!customElements.get('klevu-facet')) {
  customElements.define('klevu-facet', KlevuFacts)
}
